import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { ServicesNavItem } from './ServicesNavItem';
import { MobileServicesNav } from './MobileServicesNav';
import { business, navLinks } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ease-out ${scrolled ? 'border-white/10 bg-ink/95 backdrop-blur' : 'border-transparent bg-ink'}`} data-id="element-176" data-mp="3ba4ud8gzqfm0">
      <div className="mx-auto flex h-[72px] max-w-shell items-center gap-2 px-4 sm:gap-4 sm:px-5 lg:h-[84px] lg:px-8 xl:gap-6" data-id="element-177" data-mp="2wl4dkkvppwdk">
        <Link to="/" className="flex min-w-0 shrink items-center" data-id="element-178" data-mp="2rk6p5qk4063m">
          <span className="flex h-[66px] min-w-0 items-center lg:h-[78px]" data-id="element-179" data-mp="2mlvexepwjtkv">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="max-h-full w-auto max-w-[124px] object-contain object-left sm:max-w-[200px] lg:max-w-[290px] xl:max-w-[230px] 2xl:max-w-[270px]" data-id="element-180" data-mp="2hnttin507i68" />
          </span>
          <span className="sr-only" data-id="element-181" data-mp="3aelpbji5q4t1">{business.name}</span>
        </Link>

        <nav aria-label="Primary" className="ml-auto hidden items-center gap-4 xl:flex 2xl:gap-6" data-id="element-182" data-mp="35jpukbljd3c8">
          {navLinks.map(link => link.to === '/services' ? <ServicesNavItem key={link.to} data-id="element-183" data-mp="1xqxcz2we4tq" /> : <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `whitespace-nowrap text-[12.5px] font-semibold uppercase tracking-[0.07em] transition-colors duration-150 ease-out hover:text-white ${isActive ? 'text-brand-light' : 'text-chalk/70'}`} data-id="element-184" data-mp="3ta29w7j422cu">
                {link.label}
              </NavLink>)}
        </nav>

        <div className="ml-auto flex shrink-0 items-center gap-2 sm:gap-3 xl:ml-0" data-id="element-185" data-mp="18mttldb9bnk2">
          <a href={business.phoneHref} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-brand px-3 py-2.5 text-[13px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:gap-2 sm:px-4 lg:px-5" data-id="element-186" data-mp="1cp6qrdbxud58">
            <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-187" data-mp="2t36p4jv4xuqd" />
            <span className="hidden sm:inline" data-id="element-188" data-mp="2t13z3ztzg1ln">Call {business.phone}</span>
            <span className="sm:hidden" data-id="element-189" data-mp="2y1hyyulfk58l">Call Now</span>
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-10 w-9 shrink-0 items-center justify-center rounded-md border border-white/15 text-white sm:w-10 xl:hidden" data-id="element-190" data-mp="mdv9ax4uw6hj">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-191" data-mp="1544jouasr4kb" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-192" data-mp="106kuizck97dl" />}
          </button>
        </div>
      </div>

      {open && <div id="mobile-nav" className="border-t border-white/10 bg-ink px-5 pb-6 pt-2 xl:hidden" data-id="element-193" data-mp="1f2trtvcw5and">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-194" data-mp="1a2egf9c66d81">
            {navLinks.map(link => link.to === '/services' ? <MobileServicesNav key={link.to} isActive={location.pathname.startsWith('/services')} data-id="element-195" data-mp="3bwdmngafq4dv" /> : <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `border-b border-white/5 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] ${isActive ? 'text-brand-light' : 'text-chalk/80'}`} data-id="element-196" data-mp="27xi64tj4ku11">
                  {link.label}
                </NavLink>)}
          </nav>
        </div>}
    </header>;
}